import styled from 'styled-components'
import ButtonComponent from 'ui/src/components/controls/button'
import NumberInput from 'ui/src/components/controls/number-input'

export const Container = styled.div`
    align-items: center;
    display: flex;
`

export const Button = styled(ButtonComponent)`
    flex-shrink: 0;
`

export const TimeInput = styled(NumberInput)`
    width: 100%;

    &:first-child {
        margin-right: 15px;
    }

    &:last-child {
        margin-left: 15px;
    }
`
